module.exports = __webpack_public_path__ + "static/sharpshooter_mtg_clb-ab6c62f24def31e419411f795d5ad979.webp";